<template>
    <div>
        <div class="flex justify-between items-center mb-6">
            <div class="flex cursor-pointer text-green-600 hover:text-green-700" @click="goBack">
                <i class='bx bx-left-arrow-alt bx-sm my-auto'></i>
                <p class="text-xl font-semibold">Thêm mới tin tức</p>
            </div>
            <button @click="saveAction" class="admin-save-btn">
                <i class='bx bx-save text-white my-auto' ></i><p>Lưu</p>
            </button>
        </div>
        <div class="entry-detail grid grid-cols-1 md:grid-cols-12 gap-4">
            <div class="md:col-span-8">
                <entryName v-model="entry" @update="(e) => (entry = e)" />
                <entryType v-model="entry" @update="(e) => (entry = e)" />
                <entryDescription class="lg:col-span-2" v-model="entry" @update="(e) => (entry = e)" />
            </div>
            <entryImage class="md:col-span-4" v-model="entry" @update="(e) => (entry = e)" />
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import entryName from './partials/entry-name.vue';
import entryType from './partials/entry-type.vue';
import entryImage from './partials/entry-image.vue';
import entryDescription from './partials/entry-description.vue';
export default {
    name: 'create',
    components: {
        entryDescription, entryName, entryType, entryImage
    },
    data() {
        return {
            entry: {
                name: '',
                description: '',
                type: null,
                image: ''
            }
        }
    },
    methods: {
        ...mapActions('news', ['CreateNews']),
        saveAction() {
            let validate = {
                name: 'Tiêu đề tin tức',
                description: 'Mô tả',
                type: 'Thể loại',
                image: 'Hình ảnh'
            };
            if (!this.$validator(this.entry, validate)) return
            this.$swal.fire({
            title: 'Thêm mới tin tức?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Thêm!',
            cancelButtonText: 'Hủy'
        }).then(async (result) => {
            if (result.isConfirmed) {
                await this.CreateNews(this.entry);
                this.goBack()
            }
        })
        },
        goBack() {
            this.$router.push({
				name: "admin." + this.$route.name.split(".")[1],
			});
        }
    }
}
</script>
<style>
.entry-detail .form-group {
    margin-bottom: 0;
}
</style>